// S3 첨부 이미지 URL 헬퍼 (schedules/show, expenses/show 등 attached1~7 패턴 공용).

import type { AttachmentItem } from "./AttachmentGallery";

// 기존 각 show.tsx의 amazonS3url 문자열 조합을 그대로 이관.
// CRA는 process.env.REACT_APP_* 를 빌드 시 정적 치환하므로 모듈 상수로 둬도 동작 동일.
export const S3_BASE =
  "https://" +
  process.env.REACT_APP_AWS_S3_BUCKET_NAME +
  ".s3." +
  process.env.REACT_APP_AWS_REGION +
  ".amazonaws.com/";

// attached1~7 중 값이 있는 슬롯만 원본 슬롯 번호와 함께 절대 URL로 변환.
// 슬롯 번호를 유지해 첨부파일 관리 화면(/…/files/:id)과 대조 가능하게 한다.
export const getAttachedUrls = (record?: unknown): AttachmentItem[] => {
  const r = (record ?? {}) as Record<string, unknown>;
  const slots = [1, 2, 3, 4, 5, 6, 7].map((n) => r[`attached${n}`]);
  return slots
    .map((key, i) => ({ slot: i + 1, key }))
    .filter(
      (s): s is { slot: number; key: string } =>
        typeof s.key === "string" && s.key.trim() !== ""
    )
    .map(({ slot, key }) => ({ slot, url: S3_BASE + key }));
};
